import { Box, Heading, Text } from '@zillow/constellation-10';

import LearnAboutPremiumButton, { RENDER_AS_TYPE } from '../LearnAboutPremiumButton';

import ProductFeatureCompareTable from '../ProductFeatureCompareTable';
import PremiumUpsell from '../PremiumUpsell';

import { StyledBgFullWidth, StyledDisplayContainer, StyledTextAlignCenter } from '../StyledComponents/StyledLayout';

import { StyledExtendedContentContainer } from './StyledComponents';

const propTypes = {};
const defaultProps = {};

const PremiumCompare = () => {
  return (
    <div data-testid="PremiumCompare">
      <StyledBgFullWidth>
        <StyledExtendedContentContainer>
          <Heading level={4} fontFamily="heading-alt" css={{ marginBottom: '200', marginTop: '400' }}>
            Get the edge you need to fill your listing fast with premium
          </Heading>

          <Text asChild css={{ marginBottom: '400' }}>
            <p>
              Receive higher quality leads, gain deeper insights on how to optimize your listing, and find your perfect
              renter even faster.
            </p>
          </Text>
          <Box css={{ marginBottom: { base: 0, xl: '1200' } }}>
            <ProductFeatureCompareTable />
          </Box>
          <StyledDisplayContainer display={{ default: 'block', xxl_gte: 'none' }}>
            <StyledTextAlignCenter>
              <Box css={{ marginBlock: '1200' }}>
                <LearnAboutPremiumButton as={RENDER_AS_TYPE.BUTTON}>Learn more</LearnAboutPremiumButton>
              </Box>
            </StyledTextAlignCenter>

            <PremiumUpsell />
          </StyledDisplayContainer>
        </StyledExtendedContentContainer>
      </StyledBgFullWidth>
    </div>
  );
};

PremiumCompare.propTypes = propTypes;
PremiumCompare.defaultProps = defaultProps;

export default PremiumCompare;
